export default "__VITE_ASSET__DlAoaGbw__"